<script>
import ImageModal from '@components/modals/image-modal'

const DEFAULT_PRODUCT_IMAGE =
  'https://lupe.rappi.com/assets/images/default-product.png'

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedUnits () {
      return this.product.units || this.product.pivot.units
    },
    computedPrice () {
      return this.product.total_price || this.product.pivot.total_price
    },
    showMarkdown () {
      return (
        this.product.pivot &&
        this.product.pivot.has_price_cut &&
        this.priceWithMarkdown < this.computedPrice
      )
    },
    discountedPercentage () {
      return 1 - (this.product.pivot.percentage_price_variation / 100 || 0)
    },
    priceWithMarkdown () {
      return this.computedPrice * this.discountedPercentage
    },
  },
  created () {
    if (this.product.image.indexOf('NO-IMAGE') !== -1) {
      this.imageFallBack()
    }
  },
  methods: {
    imageFallBack () {
      this.product.image = DEFAULT_PRODUCT_IMAGE
      this.$forceUpdate()
    },
    showImage () {
      this.$modal.show(
        ImageModal,
        {
          image: this.product.image,
        },
        {
          height: 'auto',
          width: '80%',
          clickToClose: true,
          scrollable: true,
        },
        {
          'before-close': event => { },
        }
      )
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <div :class="$style.container__imgWrapper">
      <img
        :class="$style.container__image"
        :src="product.image"
        @error="imageFallBack()"
      >

      <div :class="$style.container__action">
        <img
          :class="$style.container__action__icon"
          src="@assets/images/search.svg"
          @click="showImage()"
          @error="imageFallBack()"
        >

      </div>

    </div>

    <div :class="$style.container__info">
      <p :class="[$style.container__text, $style.container__textTitle]">{{ product.name }}</p>
      <span>{{ `${computedUnits} ${computedUnits > 1 ? $t('COMPONENTS.PRODUCT.UNITS') : $t('COMPONENTS.PRODUCT.UNIT')}` }}</span>
      <div :class="$style.container__prices">
        <p
          v-if="showMarkdown"
          :class="$style.container__text"
        >
          ${{ priceWithMarkdown }}
        </p>

        <p :class="$style.container__text">
          ${{ computedPrice }}
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0.5rem;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  &__image {
    max-width: 100%;
    max-height: 100%;
    border-radius: 10px;
  }

  &__imgWrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5rem;
    height: 5rem;
  }

  &__action {
    position: absolute;
    right: 1.25rem;
    bottom: -1rem;
    background-color: $background-container;
    padding: 0.2rem;
    border-radius: 50%;

    &__icon {
      width: 1.1rem;
      height: 1.1rem;
      margin-left: 1rem;
    }
  }

  &__info {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    min-height: 5rem;
    max-height: 6rem;
    margin-left: 1rem;
    text-align: left;
  }

  &__text {
    @extend %typography-small;

    margin: 0;
    color: $charcoal-gray;

    &Title {
      font-size: 1.1rem;
      font-weight: bold;
    }
  }

  &__prices {
    display: flex;

    p {
      font-weight: 700;
    }

    p:nth-child(2n) {
      margin-left: 0.4rem;
      font-weight: 400;
      color: $blue-gray;
      text-decoration: line-through;
    }
  }
}

span {
  @extend %typography-small;

  color: $blue-gray;
}
</style>
